<div class="status-card" *ngIf="!updateStatus">
    <h3>Update Status</h3>
    <div class="status-options">
        <button class="status-btn" [class.selected]="lead.status === 'New'" (click)="selectStatus('New')">New</button>
        <!-- <button *ngIf="lead.status === 'Active'" class="status-btn" [class.selected]="lead.status === 'Active'" (click)="selectStatus('Active')">Active</button> -->
        <button class="status-btn" [class.selected]="lead.status === 'Contacted'" (click)="selectStatus('Contacted')">Contacted</button>
        <button class="status-btn" [class.selected]="lead.status === 'Onboarding'" (click)="selectStatus('Onboarding')">Onboarding</button>
        <button class="status-btn" [class.selected]="lead.status === 'Onboarded'" (click)="selectStatus('Onboarded')">Onboarded</button>
        <button class="status-btn" [class.selected]="lead.status === 'Inactive'" (click)="selectStatus('Inactive')">Inactive</button>
    </div>
  
    <div class="action-buttons">
      <button class="cancel-btn" (click)="closeModal()">Cancel</button>
      <button class="done-btn" (click)="confirmLog()">Update</button>
    </div>
</div>
  
<div class="status-card2" *ngIf="updateStatus">
    <div class="modal-header">
        <h5 class="modal-title alert">Confirmation</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="cancelLog()"></button>
      </div>
      
      <div class="modal-body">
        <div class="upload-container">
            Are you sure you want to change the status from <b>{{prevStatus}}</b> to <b>{{lead.status}}</b> ?
        </div>
      </div>
      
      <div class="modal-footer action-buttons">
        <button type="button" class="cancel-btn" (click)="cancelLog()">No</button>
        <button type="button" class="done-btn" (click)="updateLog()">Yes</button>
      </div>
</div>